module.exports = __webpack_public_path__ + "images/game/level-1.30543c3f772826237362e7df0025b0a2.png";